export const isFile = (entity: unknown): entity is File => entity instanceof File
